// extracted by mini-css-extract-plugin
export var outcomeIcon = "PickIcon-module--outcomeIcon--41f81";
export var silkSpacing = "PickIcon-module--silkSpacing--15fcf";